import React from 'react'
import { Form, Col } from '_zari/core'
import { Field } from 'formik'
import * as SubFamiliaService from 'services/subFamilia.service'

const SubFamiliaFormGroup = ({ familiaId, iError, iTouched, fIsSubmitting, values, setValues }) => {
  const [subfamilias, setSubfamilias] = React.useState([])

  React.useEffect(() => {
    if (familiaId) {
      SubFamiliaService.getSubFamilias_Select(familiaId).then(({ data }) => {
        setSubfamilias(data)
        setValues(prev => ({ ...prev, _idSubFamilia: '' }))
      })
    } else {
      setSubfamilias([])
      setValues(prev => ({ ...prev, _idSubFamilia: '' }))
    }
  }, [familiaId, setValues])

  return (
    <Form.Group>
      <Form.Label text='SUBFAMILIA' htmlFor='select-subfamilia' md={3} alignRightAt='md' />
      <Col md={9}>
        <Form.InputGroup>
          <Field name='_idSubFamilia'>
            {({ field }) => (
              <Form.Select
                {...field}
                disabled={!familiaId || fIsSubmitting}
                isInvalid={iTouched && iError}
                onChange={e => {
                  field.onChange(e)
                  setValues(prev => ({
                    ...prev,
                    _idSubFamilia: e.target.value
                  }))
                }}
                id='select-subfamilia'
              >
                <option value=''>Seleccionar</option>
                {subfamilias.map(sf => (
                  <option key={sf._id} value={sf._id}>
                    {sf.nombre}
                  </option>
                ))}
              </Form.Select>
            )}
          </Field>
        </Form.InputGroup>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default SubFamiliaFormGroup
